<app-header></app-header>
<div class="container">
  <div class="main-card">
    <app-contacts></app-contacts>
  </div>  
</div>